import { render, staticRenderFns } from "./magCpns.vue?vue&type=template&id=e43cb20c&scoped=true&"
import script from "./magCpns.vue?vue&type=script&lang=js&"
export * from "./magCpns.vue?vue&type=script&lang=js&"
import style0 from "./magCpns.vue?vue&type=style&index=0&id=e43cb20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43cb20c",
  null
  
)

export default component.exports